var map = {
	"./assets/icons/analytics-background.svg": 140,
	"./assets/icons/analytics.svg": 141,
	"./assets/icons/astro-head.svg": 142,
	"./assets/icons/commerce-background.svg": 143,
	"./assets/icons/commerce.svg": 144,
	"./assets/icons/einstein-background.svg": 145,
	"./assets/icons/einstein.svg": 146,
	"./assets/icons/employees-background.svg": 147,
	"./assets/icons/employees.svg": 148,
	"./assets/icons/heroku-background.svg": 149,
	"./assets/icons/industries-background.svg": 150,
	"./assets/icons/industries.svg": 151,
	"./assets/icons/integration-background.svg": 152,
	"./assets/icons/integration.svg": 153,
	"./assets/icons/learning-background.svg": 154,
	"./assets/icons/learning.svg": 155,
	"./assets/icons/marketing-background.svg": 156,
	"./assets/icons/marketing.svg": 157,
	"./assets/icons/no_logo-icon.svg": 75,
	"./assets/icons/partners-background.svg": 158,
	"./assets/icons/partners.svg": 159,
	"./assets/icons/philanthropy-background.svg": 160,
	"./assets/icons/philanthropy.svg": 161,
	"./assets/icons/platform-background.svg": 162,
	"./assets/icons/platform.svg": 163,
	"./assets/icons/sales-background.svg": 164,
	"./assets/icons/sales.svg": 165,
	"./assets/icons/salesforce-background.svg": 166,
	"./assets/icons/salesforce.svg": 167,
	"./assets/icons/service-background.svg": 168,
	"./assets/icons/service.svg": 169,
	"./assets/icons/slack-background.svg": 170,
	"./assets/icons/slack.svg": 171,
	"./assets/icons/small_business-background.svg": 172,
	"./assets/icons/small_business.svg": 173,
	"./assets/icons/success-background.svg": 174,
	"./assets/icons/success.svg": 175,
	"./assets/images/app/style_dots.png": 176,
	"./assets/images/app/style_squares.png": 177,
	"./assets/images/logos/salesforce.png": 74,
	"./assets/images/scenes/astro-scene_1.png": 178,
	"./assets/images/scenes/astro-scene_2.png": 179,
	"./assets/images/scenes/astro-scene_3.png": 180,
	"./assets/images/scenes/astro-scene_4.jpeg": 181,
	"./assets/images/scenes/astro-scene_5.jpeg": 182,
	"./assets/images/scenes/einstein-scene_1.png": 183,
	"./assets/images/scenes/template-1.png": 184,
	"./assets/images/scenes/template-3.png": 185,
	"./assets/images/scenes/template-4.png": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;